import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest, HttpParams } from '@angular/common/http';
import { Observable, BehaviorSubject, EMPTY} from 'rxjs';
import { map, publishReplay, refCount } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { stringify } from '@angular/compiler/src/util';

@Injectable()
export class commonDataService {

  headers: any;
  options: any;

  // country list
  private rawCountryList$Data = new BehaviorSubject<any[]>([]);
  readonly countryList$Data = this.rawCountryList$Data.asObservable();

  // project list
  private rawProjectList$Data = new BehaviorSubject<any[]>([]);
  readonly projectList$Data = this.rawProjectList$Data.asObservable();

  // school list
  private rawSchoolList$Data = new BehaviorSubject<any[]>([]);
  readonly schoolList$Data = this.rawSchoolList$Data.asObservable();

  // grade list
  private rawGradeList$Data = new BehaviorSubject<any[]>([]);
  readonly gradeList$Data = this.rawGradeList$Data.asObservable();
  
  // class list
  private rawClassList$Data = new BehaviorSubject<any[]>([]);
  readonly classList$Data = this.rawClassList$Data.asObservable();

  private rawGenderList$Data = new BehaviorSubject<any[]>([]);
  readonly genderList$Data = this.rawGenderList$Data.asObservable();

  constructor( private http: HttpClient) {
    const headersItem = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    this.headers = headersItem;
  }

  listProjects() {
    this.options = {headers: this.headers};

    this.http.get(environment.dashAPI + '/projects', this.options).subscribe(data => {
      try {
        this.rawProjectList$Data.next(Object.assign([], data));
        this.listCountries();
      } catch (err) {
        this.rawProjectList$Data.next(Object.assign([], EMPTY));
        this.rawCountryList$Data.next(Object.assign([], EMPTY));
        this.rawSchoolList$Data.next(Object.assign([], EMPTY));
        this.rawGenderList$Data.next(Object.assign([], EMPTY));
        this.rawGradeList$Data.next(Object.assign([], EMPTY));
        this.rawClassList$Data.next(Object.assign([], EMPTY));
      }
    }, error => {
      this.rawProjectList$Data.next(Object.assign([], EMPTY));
      this.rawSchoolList$Data.next(Object.assign([], EMPTY));
      this.rawCountryList$Data.next(Object.assign([], EMPTY));
      this.rawGradeList$Data.next(Object.assign([], EMPTY));
      this.rawClassList$Data.next(Object.assign([], EMPTY));
      this.rawGenderList$Data.next(Object.assign([], EMPTY));
    });
  }

  getProject(project_id) {
    this.options = {headers: this.headers};
    this.http.get(environment.dashAPI + '/project/'+project_id, this.options).subscribe(data => {
      try {
        console.log(data)
        if(data){
          this.rawProjectList$Data.next(Object.assign([], [data]));
         }
       
        this.listCountries();
      } catch (err) {
        this.rawProjectList$Data.next(Object.assign([], EMPTY));
        this.rawCountryList$Data.next(Object.assign([], EMPTY));
        this.rawSchoolList$Data.next(Object.assign([], EMPTY));
        this.rawCountryList$Data.next(Object.assign([], EMPTY));
        this.rawGradeList$Data.next(Object.assign([], EMPTY));
        this.rawClassList$Data.next(Object.assign([], EMPTY));
        this.rawGenderList$Data.next(Object.assign([], EMPTY));
      }
    }, error => {
      this.rawProjectList$Data.next(Object.assign([], EMPTY));
      this.rawSchoolList$Data.next(Object.assign([], EMPTY));
      this.rawCountryList$Data.next(Object.assign([], EMPTY));
      this.rawGradeList$Data.next(Object.assign([], EMPTY));
      this.rawClassList$Data.next(Object.assign([], EMPTY));
      this.rawGenderList$Data.next(Object.assign([], EMPTY));
    });
  }

  listCountries() {
    this.projectList$Data.subscribe( data => {
      let countries: any = [];
      data.forEach( p => {
        if (p && p.country && p.country.name) {
          let x = countries.findIndex( (c: any) => c.name === p.country.name);
          if (x < 1)
            countries.push(p.country);
           
        }
      });
      // console.log("Countries Length >>>>> "+countries.length)
      this.rawCountryList$Data.next(Object.assign([], countries));
    });
  }

  listSchools(project_id: any) {
    this.http.get(environment.dashAPI + '/schools/project/' + project_id, this.options).subscribe(data => {
      try {
        this.rawSchoolList$Data.next(Object.assign([], data));
        this.rawGradeList$Data.next(Object.assign([], EMPTY));
        this.rawClassList$Data.next(Object.assign([], EMPTY));
      } catch (err) {
        this.rawSchoolList$Data.next(Object.assign([], EMPTY));
        this.rawGradeList$Data.next(Object.assign([], EMPTY));
        this.rawClassList$Data.next(Object.assign([], EMPTY));
      }
    }, error => {
      this.rawSchoolList$Data.next(Object.assign([], EMPTY));
      this.rawGradeList$Data.next(Object.assign([], EMPTY));
      this.rawClassList$Data.next(Object.assign([], EMPTY));
    });
  }

  listGrade(school_id: any) {
    this.http.get(environment.dashAPI + '/grades/school/' + school_id, this.options).subscribe(data => {
      try {
        this.rawGradeList$Data.next(Object.assign([], data));
        this.rawClassList$Data.next(Object.assign([], EMPTY));
      } catch (err) {
        this.rawGradeList$Data.next(Object.assign([], EMPTY));
        this.rawClassList$Data.next(Object.assign([], EMPTY));
      }
    }, error => {
      this.rawGradeList$Data.next(Object.assign([], EMPTY));
      this.rawClassList$Data.next(Object.assign([], EMPTY));
    });
  }

  listClass(grade_id: any) {
    this.gradeList$Data.subscribe( data => {
      const x: any = data.filter(c => c._id === grade_id);
      if (x && x.length)
        this.rawClassList$Data.next(Object.assign([], x[0].classes));
    });
  }

  listGender() {
    this.http.get(environment.dashAPI + '/gender', this.options).subscribe(data => {
    
        this.rawGenderList$Data.next(Object.assign([], data));
    }); 
  }

  // for user type and gender filters check user usage data service

}
